const DarkTheme = {
  mode: 'dark',
  // Primary
  Bg1: '#131314',
  text1: '#E7E8EA',
  svg1: '#e6e6e6',
  svg2: '#444444',
  border1: '#2f2f30',
  modalBg1: '#242323',
  boxShadow1: 'rgba(255, 255, 255, 0.2) 0px 0px 2px 0px, rgba(255, 255, 255, 0.1) 0px 0px 2px 0px',
  hoverBg1: '#2C2C2E',
  fieldBorder1: '#444444',
  fieldBorderHover1: '#828282',
  fieldText1: '#FFFFFF99',
  fieldDisable1: '#FFFFFF0A',
  lightGray: '#313131',
  lightGrayHover: '#3b3b3b',
  lightBlue: "#1b232b",
  disableText1: '#989898',
  disableBg1: '#666666',
  red1: '#fc223b',
  tabBg1: '#2d2d2d',
  tabText1: '#828282',
  tab2: '#131314e6',

  gray: {
    1: '#D5D5D5',
  },
  colors: {
    2: '#FFFFFF',
    3: '#262626',
    4: '#2d90FF',
    5: '#4B4B4B',
  },
};

export default DarkTheme;
